import { Button, CircularProgress, Dialog, makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react'
import { checklist_document_result, useGetChecklistDocumentWithContent } from '../../../../services/ChecklistDocument/ChecklistDocumentRead/ChecklistDocumentRead';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles(theme => ({
    root: {
        position: "relative",
    },
    page: {
        
    },
    buttonToClose: {
        position: "sticky",
        bottom: theme.spacing(2),
        left: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: "white"
    }
}))

export const testIds = {
    document: "document",
    buttonToClose: "button_to_close_document_dialog" 
}

export interface ChecklistDocumentDialogProps {
    open: boolean;
    pageNumber: number;
    onCloseDialog: () => void
    url: string;
}   

const ChecklistDocumentDialog: React.FC<ChecklistDocumentDialogProps> = ({ open,  pageNumber, onCloseDialog, url }) => {
    const { data: checklistDocument, loading: loadingChecklistDocument } = useGetChecklistDocumentWithContent(url)
    const { t } = useTranslation()
    const classes = useStyles()

    const document: checklist_document_result | null = useMemo(() => {
        return checklistDocument ? `${checklistDocument}#page=${pageNumber}` : null
    }, [ pageNumber, checklistDocument])

    return (
        <Dialog
            open={open}
            maxWidth="xl"
            onClose={onCloseDialog}
        >
            {loadingChecklistDocument
                ? <CircularProgress />
                : <div 
                    data-testid={testIds.document}
                    className={classes.root}>
                    <iframe
                        title="checklist_document_view"
                        width={1800}
                        height={900}
                        src={document ? document : ""}
                    />
                    <Button data-testid={testIds.buttonToClose} className={classes.buttonToClose} onClick={onCloseDialog}>{t("common:close")}</Button>
                </div>
            }
            
        </Dialog>
    )
}

export default ChecklistDocumentDialog